// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var defaultValue = {
  version: "0",
  uuid: "",
  lang: "en",
  auth_token: "",
  version_code: "0"
};

var context = React.createContext(defaultValue);

function getRnrParams(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  getRnrParams ,
  
}
/* context Not a pure module */
